import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import Sterilization from './Sterilization'
import RegisterProductModern from '../RegisterProductModern'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import SimpleButton from '../common/SimpleButton'
import Breadcrumb from '../common/Breadcrumb'
import { hasCorporateAdminModulesPermission } from '../../utils/permissionValidation'
import { trackEvent, gaActions, gaCategories } from '../../utils/ga4'
import { COLTENE_BRANCH_UUID } from '../../actions/root'
import './reports.scss'

const Reports = (props) => {
  const { t } = useTranslation()
  const location = useLocation()
  const canGoBack = location.state && location.state.withBackNavigation
  const [showRegisterProduct, setShowRegisterProduct] = useState(false)
  const [canRegisterProduct, setCanRegisterProduct] = useState(false)

  useEffect(() => {
    const isCorporateAdmin = hasCorporateAdminModulesPermission(props.userPermissions)
    if (isCorporateAdmin) {
      const colteneBranchId = localStorage.getItem(COLTENE_BRANCH_UUID)
      const isBranchAdmin = props.userBranches?.find((branch) => branch.branchUuid === colteneBranchId)?.email === props.authedUser?.email

      if (isBranchAdmin) {
        setCanRegisterProduct(true)
      }

      return
    }

    setCanRegisterProduct(true)
  }, [props.userPermissions, props.userBranches])

  useEffect(() => {
    // Track page view when component mounts
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.instrumentReprocessingReportsPage,
      label: 'Instrument Reprocessing Reports Page: Page View',
    })
  }, [])

  return (
    <div className="reports-wrapper">
      <Breadcrumb path={window.location.pathname} withBackNavigation={canGoBack} />
      <DashboardHeader headerText={t('nav.reports')}>
        {canRegisterProduct && (
          <SimpleButton className="submit-button" onClick={() => setShowRegisterProduct(true)}>
            {t('device_context.register_product')}
          </SimpleButton>
        )}
      </DashboardHeader>
      <div className="separator" />
      <Sterilization />
      {showRegisterProduct && <RegisterProductModern closeModal={() => setShowRegisterProduct(false)} />}
    </div>
  )
}

function mapStateToProps({ authedUser, userPermissions, userCompany }) {
  return {
    authedUser,
    userPermissions,
    userBranches: userCompany?.userBranches || [],
  }
}

export default connect(mapStateToProps)(Reports)
